import { useMessages } from "../context/MessagesContext";
import { Card, CardContent } from "../components/ui/card";
import {
  Target,
  Eye,
  Heart,
  Award,
  Shield,
  Lightbulb,
  Users,
  Leaf
} from "lucide-react";
import nosotros from "../assets/about/nosotros.webp";

const Nosotros = () => {
  const labels = useMessages();

  const values = [
    {
      icon: Award,
      title: labels["about.us.excelence.title"],
      description: labels["about.us.excelence.description"],
      color: "text-excelencia"
    },
    {
      icon: Users,
      title: labels["about.us.professionalism.title"],
      description: labels["about.us.professionalism.description"],
      color: "text-profesionalismo"
    },
    {
      icon: Lightbulb,
      title: labels["about.us.innovation.title"],
      description: labels["about.us.innovation.description"],
      color: "text-innovacion"
    },
    {
      icon: Shield,
      title: labels["about.us.security.title"],
      description: labels["about.us.security.description"],
      color: "text-seguridad"
    },
    {
      icon: Heart,
      title: labels["about.us.wellness.title"],
      description: labels["about.us.wellness.description"],
      color: "text-bienestar"
    },
    {
      icon: Leaf,
      title: labels["about.us.sustainability.title"],
      description: labels["about.us.sustainability.description"],
      color: "text-sostenibilidad"
    }
  ];

  return (
    <section id="nosotros" className="scroll-mt-24">
      <div>
        {/* Header */}
        <h2 className="section-title">
          {labels["about.us.title"]}
        </h2>

        {/* Team Image */}
        <div className="relative rounded-2xl overflow-hidden mb-10">
          <img
            src={nosotros}
            alt={labels["about.us.title"] || "Equipo Hidromed"}
            className="w-full h-96 object-cover"
          />
          <div className="absolute inset-0 bg-black/20" /> {/* sombra suave */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center text-white px-8 lg:px-16">
              <h3 className="text-2xl lg:text-3xl font-bold mb-4 text-white drop-shadow-[0_3px_10px_rgba(0,0,0,0.55)]">
                {labels["about.us.image.1"]}
              </h3>
              <p className="text-base md:text-lg lg:text-xl text-white max-w-2xl drop-shadow-[0_3px_10px_rgba(0,0,0,0.55)]">
                {labels["about.us.image.2"]}
              </p>
            </div>
          </div>
        </div>

        {/* Mission & Vision Grid */}
        <div className="grid lg:grid-cols-2 gap-12 mb-10">
          {/* Mission */}
          <Card className="card-nosotros">
            <CardContent className="p-8">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 bg-accentGold rounded-full flex items-center justify-center">
                  <Target className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-foreground">{labels["about.us.mision.title"]}</h3>
              </div>

              <p className="body-copy text-muted-foreground leading-relaxed">
                {labels["about.us.mision.info"]}
              </p>
            </CardContent>
          </Card>

          {/* Vision */}
          <Card className="card-nosotros">
            <CardContent className="p-8">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 bg-accentGold rounded-full flex items-center justify-center">
                  <Eye className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-foreground">{labels["about.us.vision.title"]}</h3>
              </div>

              <p className="body-copy text-muted-foreground leading-relaxed">
                {labels["about.us.vision.info"]}
              </p>
            </CardContent>
          </Card>
        </div>

        {/* Values */}
        <div className="mb-16">
          <div className="text-center mb-12">
            <h3 className="text-2xl md:text-3xl font-bold text-foreground mb-4">
              {labels["about.us.values.1"]}
            </h3>
            <p className="lead-copy text-muted-foreground max-w-3xl mx-auto">
              {labels["about.us.values.2"]}
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {values.map((value, index) => {
              const IconComponent = value.icon;
              return (
                <Card key={index} className="card-nosotros group cursor-pointer">
                  <CardContent className="p-6">
                    <div className="flex items-center gap-4 mb-4">
                      <div className={`w-12 h-12 rounded-full flex items-center justify-center bg-opacity-10 ${value.color}`}>
                        <IconComponent className={`w-6 h-6 ${value.color}`} />
                      </div>
                      <h4 className="text-2xl font-bold text-foreground">{value.title}</h4>
                    </div>
                    <p className="body-copy text-muted-foreground leading-relaxed">
                      {value.description}
                    </p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Nosotros;
